import "core-js/modules/es.array.reverse.js";
var _class, _CogLoadableStratum, _class2, _descriptor, _CogCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { computed, makeObservable, observable, onBecomeObserved, onBecomeUnobserved, runInAction } from "mobx";
import GeographicTilingScheme from "terriajs-cesium/Source/Core/GeographicTilingScheme";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import WebMercatorTilingScheme from "terriajs-cesium/Source/Core/WebMercatorTilingScheme";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import CogCatalogItemTraits from "../../../Traits/TraitsClasses/CogCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";

/**
 * Loadable stratum for overriding CogCatalogItem traits
 */
let CogLoadableStratum = (_class = (_CogLoadableStratum = class CogLoadableStratum extends LoadableStratum(CogCatalogItemTraits) {
  constructor(model) {
    super();
    this.model = model;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new CogLoadableStratum(model);
  }
  get shortReport() {
    var _this$model$_imageryP, _this$model$_imageryP2;
    return this.model.terria.currentViewer.type === "Leaflet" ?
    // Warn for 2D mode
    i18next.t("models.commonModelErrors.3dTypeIn2dMode", this) : (_this$model$_imageryP = this.model._imageryProvider) !== null && _this$model$_imageryP !== void 0 && _this$model$_imageryP.tilingScheme &&
    // Show warning for experimental reprojection freature if not using EPSG 3857 or 4326
    isCustomTilingScheme((_this$model$_imageryP2 = this.model._imageryProvider) === null || _this$model$_imageryP2 === void 0 ? void 0 : _this$model$_imageryP2.tilingScheme) ? i18next.t("models.cogCatalogItem.experimentalReprojectionWarning", this) : undefined;
  }
  get rectangle() {
    var _this$model$_imageryP3;
    const rectangle = (_this$model$_imageryP3 = this.model._imageryProvider) === null || _this$model$_imageryP3 === void 0 ? void 0 : _this$model$_imageryP3.rectangle;
    if (!rectangle) {
      return;
    }
    const {
      west,
      south,
      east,
      north
    } = rectangle;
    return {
      west: CesiumMath.toDegrees(west),
      south: CesiumMath.toDegrees(south),
      east: CesiumMath.toDegrees(east),
      north: CesiumMath.toDegrees(north)
    };
  }
}, _defineProperty(_CogLoadableStratum, "stratumName", "cog-loadable-stratum"), _CogLoadableStratum), _applyDecoratedDescriptor(_class.prototype, "shortReport", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _class);
StratumOrder.addLoadStratum(CogLoadableStratum.stratumName);

/**
 * Creates a Cloud Optimised Geotiff catalog item.
 *
 * Currently it can render EPSG 4326/3857 COG files. There is experimental
 * support for other projections, however it is less performant and could have
 * unknown issues.
 */
let CogCatalogItem = (_class2 = (_CogCatalogItem = class CogCatalogItem extends MappableMixin(CatalogMemberMixin(CreateModel(CogCatalogItemTraits))) {
  get type() {
    return CogCatalogItem.type;
  }
  constructor(id, terria, sourceReference) {
    super(id, terria, sourceReference);
    /**
     * Private imageryProvider instance. This is set once forceLoadMapItems is
     * called.
     */
    _initializerDefineProperty(this, "_imageryProvider", _descriptor, this);
    /**
     * The reprojector function to use for reprojecting non native projections
     *
     * Exposed here as instance variable for stubbing in specs.
     */
    _defineProperty(this, "reprojector", reprojector);
    makeObservable(this);
    this.strata.set(CogLoadableStratum.stratumName, new CogLoadableStratum(this));

    // Destroy the imageryProvider when `mapItems` is no longer consumed. This
    // is so that the webworkers and other resources created by the
    // imageryProvider can be freed. Ideally, there would be a more explicit
    // `destroy()` method in Terria life-cycle so that we don't have to rely on
    // mapItems becoming observed or unobserved.
    onBecomeUnobserved(this, "mapItems", () => {
      if (this._imageryProvider) {
        this._imageryProvider.destroy();
        this._imageryProvider = undefined;
      }
    });

    // Re-create the imageryProvider if `mapItems` is consumed again after we
    // destroyed it
    onBecomeObserved(this, "mapItems", () => {
      if (!this._imageryProvider && !this.isLoadingMapItems) {
        this.loadMapItems(true);
      }
    });
  }
  async forceLoadMapItems() {
    if (!this.url) {
      return;
    }
    const url = proxyCatalogItemUrl(this, this.url);
    const imageryProvider = await this.createImageryProvider(url);
    runInAction(() => {
      this._imageryProvider = imageryProvider;
    });
  }
  get mapItems() {
    const imageryProvider = this._imageryProvider;
    if (!imageryProvider) {
      return [];
    }
    return [{
      show: this.show,
      alpha: this.opacity,
      // The 'requestImage' method in Cesium's ImageryProvider has a return type that is stricter than necessary.
      // In our custom ImageryProvider, we return ImageData, which is also a valid return type.
      // However, since the current Cesium type definitions do not reflect this flexibility, we use a TypeScript ignore comment ('@ts-ignore')
      // to suppress the type checking error. This is a temporary solution until the type definitions in Cesium are updated to accommodate ImageData.
      // @ts-expect-error - The return type of 'requestImage' method in our custom ImageryProvider can be ImageData, which is not currently allowed in Cesium's type definitions, but is fine.
      imageryProvider,
      clippingRectangle: this.cesiumRectangle
    }];
  }

  /**
   * Create TIFFImageryProvider for the given url.
   */
  async createImageryProvider(url) {
    // lazy load the imagery provider, only when needed
    const [{
      default: TIFFImageryProvider
    }, {
      default: proj4
    }] = await Promise.all([import("terriajs-tiff-imagery-provider"), import("proj4-fully-loaded")]);
    return runInAction(() => TIFFImageryProvider.fromUrl(url, {
      credit: this.credit,
      tileSize: this.tileSize,
      maximumLevel: this.maximumLevel,
      minimumLevel: this.minimumLevel,
      enablePickFeatures: this.allowFeaturePicking,
      hasAlphaChannel: this.hasAlphaChannel,
      // used for reprojecting from an unknown projection to 4326/3857
      // note that this is experimental and could be slow as it runs on the main thread
      projFunc: this.reprojector(proj4),
      // make sure we omit `undefined` options so as not to override the library defaults
      renderOptions: omitUndefined({
        nodata: this.renderOptions.nodata,
        convertToRGB: this.renderOptions.convertToRGB,
        resampleMethod: this.renderOptions.resampleMethod
      })
    }));
  }
}, _defineProperty(_CogCatalogItem, "type", "cog"), _CogCatalogItem), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "_imageryProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _class2);
export { CogCatalogItem as default };
/**
 * Function returning a custom reprojector
 */
function reprojector(proj4) {
  return code => {
    if (![4326, 3857, 900913].includes(code)) {
      try {
        const prj = proj4("EPSG:4326", "EPSG:".concat(code));
        if (prj) return {
          project: prj.forward,
          unproject: prj.inverse
        };
      } catch (e) {
        console.error(e);
      }
    }
  };
}

/**
 * Returns true if the tilingScheme is custom
 */
function isCustomTilingScheme(tilingScheme) {
  // The upstream library defines a TIFFImageryTillingScheme but it is not
  // exported so we have to check if it is not one of the standard Cesium
  // tiling schemes. Also, because TIFFImageryTillingScheme derives from
  // WebMercatorTilingScheme, we cannot simply do an `instanceof` check, we
  // compare the exact constructor instead.
  return tilingScheme.constructor !== WebMercatorTilingScheme && tilingScheme.constructor !== GeographicTilingScheme;
}
function omitUndefined(obj) {
  return Object.fromEntries(Object.entries(obj).filter(_ref => {
    let [_, value] = _ref;
    return value !== undefined;
  }));
}